import PropTypes from 'prop-types';
import React, { Component } from 'react';
import CollapsableCard from 'components/CollapsableCard';
import { EditableTable } from 'components/EditableTable';
import S from 'styles/table.scss';

class LineItemTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isInEditMode: this.props.editableOnly,
      actions: [{ icon: 'mode_edit', text: 'edit', onClick: this.onEditClick }],
      makeSticky: false,
    };
  }

  onEditClick = (event) => {
    event.stopPropagation();
    const { requestLineItemList, toggleEditMode = null } = this.props;
    if (requestLineItemList) this.props.requestLineItemList();
    if (toggleEditMode !== null) toggleEditMode(true);
    this.runLPAStep3();
    this.setState({
      isInEditMode: true,
      actions: [{ icon: 'done', text: 'done', onClick: this.onDoneClick }],
    });
  }

  onDoneClick = (event) => {
    const { toggleEditMode = null, cv } = this.props;
    event.stopPropagation();
    if (toggleEditMode !== null) toggleEditMode(false);
    this.setState({
      isInEditMode: false,
      actions: [{ icon: 'mode_edit', text: 'edit', onClick: this.onEditClick }],
    });
    this.props.refreshList();
    /*
     * This is needed for now because sometimes a given table is updated even
     * if the props are not, so displayed values are not what they should be.
     */
    if (!cv) window.location.reload();
  }

  runLPAStep3 = () => {
    const step3Btn = document.getElementById('runStep3Btn');
    if (step3Btn) step3Btn.click();
  }

  createNewChildren = () => {
    const newChildren = [];
    this.props.children.forEach(child => child.props.children.forEach(ch =>
      newChildren.push(ch)));
    return newChildren;
  }

  handleScroll = () => (this.props.accountingTable ? null : this.setState({ makeSticky: true }));

  render = () => {
    const { isInEditMode, actions: stateActions, makeSticky } = this.state;
    const { total, title, titleNote, children, readOnly, editableOnly,
      actions, editableActions, footer, canViewTotal, hasCreatableRow,
      diffChildren, actionBtnPrefix, adminTable } = this.props;
    window.onscroll = this.handleScroll;
    const noShowEdit = readOnly || editableOnly;
    let cardActions = noShowEdit ? [] : stateActions;
    cardActions = cardActions.concat(isInEditMode ? editableActions : actions);
    const displayedTotal = total > 0 ? total.toFixed(2) : '0.00';
    return (<CollapsableCard
      actionBtnPrefix={actionBtnPrefix}
      title={title}
      titleNote={titleNote}
      actions={cardActions}
    >
      <div id="tableWrapper" className={S.tableWrapper}>
        <EditableTable
          isEditable={isInEditMode}
          hasCreatableRow={hasCreatableRow}
          title={title}
          makeSticky={makeSticky}
        >
          {diffChildren ? this.createNewChildren() : children}
        </EditableTable>
        {!adminTable && canViewTotal && <div className={S.totalContainer}>
          <div className={S.total}>
            Total: ${displayedTotal}
          </div>
        </div>}
        {footer && footer}
      </div>
    </CollapsableCard>);
  }
}

LineItemTable.defaultProps = {
  total: 0,
  readOnly: false,
  editableOnly: false,
  hasCreatableRow: true,
  editableActions: [],
  actions: [],
  canViewTotal: true,
  cv: false,
  accountingTable: false,
  adminTable: false,
};

LineItemTable.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.node,
  titleNote: PropTypes.string,
  requestLineItemList: PropTypes.func,
  refreshList: PropTypes.func,
  toggleEditMode: PropTypes.func,
  total: PropTypes.number,
  readOnly: PropTypes.bool,
  editableOnly: PropTypes.bool,
  hasCreatableRow: PropTypes.bool,
  editableActions: PropTypes.array,
  actions: PropTypes.array,
  footer: PropTypes.node,
  canViewTotal: PropTypes.bool,
  diffChildren: PropTypes.bool,
  actionBtnPrefix: PropTypes.string,
  cv: PropTypes.bool,
  accountingTable: PropTypes.bool,
  adminTable: PropTypes.bool,
};

export default LineItemTable;



// WEBPACK FOOTER //
// ./client/app/shared/components/LineItemTable/index.jsx